import { ActionReducerMapBuilder, createSlice } from '@reduxjs/toolkit'
import { ProductInitialStateType } from 'features/Product/@types/Product'
import { withLoadingReducer } from 'utils/reducerHandler'
import {
  fetchProductList,
  fetchProductVendorFeatureFlag,
  fetchProductVendorsCount,
  updateProductStatus,
  SLICE_NAME_PRODUCT,
} from './thunk'

const initialState: ProductInitialStateType = {
  isLoading: false,
  products: [],
  pagination: null,
  // To:do Remove product vendor feature flag after stable release
  isProductVendorsFFactive: false,
  productVendorsCount: [],
}

const slice = createSlice({
  name: SLICE_NAME_PRODUCT,
  initialState,
  reducers: {
    resetProductState: () => initialState,
    setLoading: (state, action) => {
      state.isLoading = action.payload
    },
  },
  extraReducers: withLoadingReducer(
    (builder: ActionReducerMapBuilder<ProductInitialStateType>) => {
      builder
        .addCase(fetchProductList.fulfilled, (state, action) => {
          state.products = action.payload.data
        })
        .addCase(fetchProductVendorsCount.fulfilled, (state, action) => {
          state.productVendorsCount = action.payload
        })
        // To:do Remove product vendor feature flag after stable release
        .addCase(fetchProductVendorFeatureFlag.fulfilled, (state, action) => {
          state.isProductVendorsFFactive = action.payload === 'true'
        })
    },
    [fetchProductList, updateProductStatus],
  ),
})

export const { resetProductState, setLoading } = slice.actions

export default slice.reducer
